/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
/// <reference path="../../_ext/editors/grideditorbase.ts" />

namespace TabAurous.Production {

    import fld = DismantlingReturnItemsRow.Fields;

    @Serenity.Decorators.registerClass()
    export class DismantlingReturnItemsEditor extends _Ext.ItemGridEditor<DismantlingReturnItemsRow> {


        protected getColumnsKey() { return "Production.DismantlingReturnItems"; }
        protected getDialogType() { return DismantlingReturnItemsDialog; }
        protected getLocalTextPrefix() { return DismantlingReturnItemsRow.localTextPrefix; }
        protected form: DismantlingReturnItemsForm;

        private pendingChanges: Q.Dictionary<any> = {};
 
        public canUpdate: number;
        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            this.slickGrid.setOptions({ forceFitColumns: true, rowHeight: 30 });

            this.view.onDataChanged.subscribe(() => {
                if (this.view.getItems().length > 0) {
                    (this.parentDialog as DismantlingReturnDialog).CalculateAmountandTax(this.view.getItems());
                }
            })
            this.slickGrid.onRender.subscribe(() => {
                // call of the function that will bind the editors with the fields (<input>) of the html page
                this.SetInlineLookupEditor();

            });
        }

        // #region Column Add -Remove
        protected getColumns() {

            var columns = super.getColumns();

            var num = ctx => ColumnFormatter.numericInputFormatter(ctx, this);
            var int = ctx => ColumnFormatter.integerInputFormatter(ctx, this);
            var wt = ctx => ColumnFormatter.WeightFormatter(ctx, this);
            var amt = ctx => ColumnFormatter.AmountFormatter(ctx, this);
            var str = ctx => ColumnFormatter.stringInputFormatter(ctx, this);

            var Department = Q.first(columns, x => x.field === fld.DepartmentId);
            Department.referencedFields = [fld.DepartmentId];
            Department.format = ctx => {
                var width = (ctx.column.width) as number - 10;
                return '<input type="hidden" style="text-align: right; width:' + width + 'px;" id="LocId' + ctx.row + '" title="Location" />';
            };
            Q.first(columns, x => x.field === fld.ReceivedPieces).format = int;
            Q.first(columns, x => x.field === fld.ReceivedWeight).format = wt;

            //To Add Delete Button on Item Row
            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });

            return columns;
        }
        public SetInlineLookupEditor() {
            // course of all the lines present in the grid
            var Items = this.view.getItems();
            if (Items.length > 0)
                for (let Item in Items) {
                    this.InlineLookup(Item, Items);
                }
        }

        private InlineLookup(RowIndex: string, Items: DismantlingReturnItemsRow[]) {

            var select = $("#LocId" + RowIndex);

            if (!select.hasClass("select2-offscreen")) {

                let opt: Serenity.LookupEditorOptions = {
                    lookupKey: OMS.DepartmentMasterRow.lookupKey
                };
                var Editor = new TabAurous.InlineLookupEditor($("#LocId" + RowIndex), opt);
                if (this.isReadOnly == true) {
                    q.showAndDisableField(Editor);
                }

                Editor.value = Q.toId(Items[RowIndex].DepartmentId);
                Editor.changeSelect2(e => {
                    Items[RowIndex].DepartmentId = Q.toId(Editor.value);
                });
            }
            else {
                if (this.isReadOnly == false) {
                    select.closest('.slick-cell').find('.select2-container-disabled').removeClass('select2-container-disabled');
                    select.removeAttr("readonly");
                }
            }
        }


        //#region  ItemGrid Inline Editor

        // **** Onclick Event ****
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);


            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row);
            //To Set Master Product Image
            //     PurchaseMasterDialog.image = item.ImageName;
            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('delete-row')) {
                    if (this.canUpdate == 0) {
                        Q.alert("Voucher is ReadOnly can not Delete!!")
                    }
                    else {
                        //TODO: Validate for TransItemID in RefTransItemID in Stock
                        Q.confirm('Are you sure want to Delete? ', () => {

                            var id = this.id(item);
                            let refid: any;
                            TabAurous.Stock.StockItemService.CheckItemTransaction(
                                {
                                    RefTransId: item.TransId,
                                    RefTransItemId: item.TransItemId,
                                    Line_No: (item.Line_No),
                                    ProductId: (item.ProductId)
                                }
                                , response => {
                                    refid = response.Entities
                                }, { async: false })
                            if (refid != null && refid.length > 0) {
                                if (refid[0].TransId != null || refid[0].TransId > 0) {
                                    Q.alert("This Item has been used in transactions Can Not Delete!");
                                    return;
                                }
                            } else {
                                 
                                this.view.deleteItem(id); 
                            }
                        });
                    }
                    this.view.refresh();
                    (this.parentDialog as DismantlingReturnDialog).CalculateAmountandTax(this.view.getItems());

                }

                if (target.hasClass('edit numeric')) {
                    super.onClick(e, row, cell);
                }
            }

            if (target.hasClass('edit numeric')) {
                e.preventDefault();
                //TODO: Need to add System Parameter to enable disable blocking
                this.canUpdate = this.readOnly ? 0 : 1;
                var input = $(e.target);
                if (input != undefined) {
                    if (this.canUpdate == 0) {
                        //Check Editable
                        target.addClass('readonly');
                        target.blur();
                        Q.alert("Voucher is ReadOnly can not Edit!!")

                    }
                    else if (this.canUpdate == 1) {
                        target.removeClass('readonly');
                        var input = $(e.target);
                        var y = input.data();
                        if (y.field == "Weight" && item.ItemTypeId == 101) {
                            target.addClass('readonly');
                            target.blur();
                        }
                        else if (y.field == "UnitRate" && item.ItemTypeId == 101) {
                            target.addClass('readonly');
                            target.blur();
                        }
                        else if (y.field == "Pieces" && item.ItemTypeId == 104) {
                            target.addClass('readonly');
                            target.blur();
                        }
                    }

                }

                this.view.refresh();
                (this.parentDialog as DismantlingReturnDialog).CalculateAmountandTax(this.view.getItems());

            }

        }

        //Row Edit Event handler
        private inputsChange(e: JQueryEventObject,) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row);
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');
            var id = this.id(item);
            var pending = this.pendingChanges[id];

            // *** Format Number ***
            var effective = this.getEffectiveValue(item, field);
            var oldText: string = input.hasClass('numeric')
                ? Q.formatNumber(effective, '0.00')
                : effective as string;

            var value;

            // *** Validate Decimal & Integer***
            if (field === fld.ReceivedWeight || field === fld.LossWeight) {
                value = Q.parseDecimal(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Decimal'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            } else if (field === fld.ReceivedPieces || field === fld.LossPieces) {
                value = Q.parseInteger(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Integer'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            }
            else if (input.hasClass('numeric')) {
                var i = Q.parseInteger(text);
                if (isNaN(i) || i > 32767 || i < 0) {
                    Q.notifyError(Q.text('Validation.Integer'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
                value = i;
            }
            else {
                value = text;
            }

            // *** Update Weight, Amount etc on Pieces Change***
            if (field === fld.ReceivedPieces && value > 0) {

                if (item.ItemTypeId == 105) {
                    if (value <= item.Pieces) {
                        item[field] = value;

                        if (value != item.Pieces) {
                            var remaining = item.Pieces - value;

                            Q.confirm('Remaining ' + remaining + ',Do you want to set as Loss', () => {
                                item.LossPieces = remaining;
                                this.view.updateItem(id, item);
                                this.view.refresh();
                            });
                        }
                    }
                }
            }
            if (field === fld.LossPieces && value > 0) {

                if (item.ItemTypeId == 105) {
                    if ((value + item.ReceivedPieces) <= item.Pieces) {
                        item[field] = value;
                        if ((value + item.ReceivedPieces) != item.Pieces) {

                            var remaining = item.Pieces - (value + item.ReceivedPieces);
                            Q.confirm('Remaining ' + remaining + ',Do you want to set as Loss', () => {
                                item.ReceivedPieces = remaining;
                                this.view.updateItem(id, item);
                                this.view.refresh();
                            });

                        }
                    }
                }
                item[field] = value;
            }
            // **** Allow to Set Weight for RM ****
            if (field === fld.LossWeight && value > 0) {
                if (item.ItemTypeId == 104 || item.ItemTypeId == 105) {
                    if ((value + item.ReceivedWeight) <= item.Weight) {
                        item[field] = value;

                        if ((value + item.ReceivedWeight) != item.Weight) {
                            var remaining = item.Weight - item.ReceivedWeight;

                            Q.confirm('Remaining ' + remaining + ',Do you want to set as Loss', () => {
                                item.ReceivedWeight = remaining;
                                this.view.updateItem(id, item);
                                this.view.refresh();
                            });

                        }
                    }
                }

            }
            if (field === fld.ReceivedWeight && value > 0) {
                if (item.ItemTypeId == 104 || item.ItemTypeId == 105) {
                    if (value <= item.Weight) {
                        item[field] = value;

                        if (value != item.Weight) {
                            var remaining = item.Weight - value;
                            Q.confirm('Remaining ' + remaining + ',Do you want to set as Loss', () => {

                                item.LossWeight = remaining
                                this.view.updateItem(id, item);
                                this.view.refresh();
                            });

                        }
                    }
                }

            }


            // *** Set Department ***
            if (field === fld.DepartmentId && value > 0) {
                item[field] = value;

            }

            this.view.updateItem(id, item);
            this.view.refresh();
            (this.parentDialog as DismantlingReturnDialog).CalculateAmountandTax(this.view.getItems());

      

            if (input.hasClass('numeric'))
                value = Q.formatNumber(value, '0.000');

            if (input.hasClass('integer'))
                value = Q.formatNumber(value, '0');

            input.val(value).addClass('dirty');
        }


        private getEffectiveValue(item, field: any): any {
            var id = this.id(item);
            var pending = this.pendingChanges[id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }
            return item[field];
        }

        protected onViewProcessData(response) {
            this.pendingChanges = {};
            return super.onViewProcessData(response);
        }

        // #endregion

        // #region Buttons Add-Remove
        protected getButtons() {
            let buttons = super.getButtons();
            buttons = buttons.filter(x => x.cssClass != "add-button");

            // *** Add Select Button to Grid Editor ***
            buttons.push({
                title: "Select Products",
                cssClass: "stock-button",
                hotkey: "alt+k",
                hint: 'alt+k',
                onClick: () => {

                    var stockgrid = DismantlingReturnSelectGrid;
                    var filters: _Ext.SelectGridFilters = {
                        FilterItems: 4
                    }

                    var pickerDialog = new _Ext.GridItemPickerDialog({
                        gridType: stockgrid, multiple: true, title: "Select Items",
                        preSelectedKeys: this.value.map(k => k.ProductId), GridFilters: filters
                    }); 

                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId) });
                        //var self = this;
                        var details = [];
                      

                        selectedItems2.forEach(function (value: DismantlingReturnItemsRow) {
                            value.LossWeight = 0;
                            value.LossPieces = 0;
                            value.ReceivedWeight = 0;
                            value.ReceivedPieces = 0;
                            //value.LotNo = value.ItemTypeId == 105 ? FormatHelper.GetFormats("Lot") : "";
                            details.push(value);
                        });

                        // #region Items to Grid
                        //for (let value of selectedItems2)

                        //if (this.view.getItems().length > 0) {
                        //    self.TotalItems = details.length + this.view.getItems().length;
                        //}
                        //else {
                        //    self.TotalItems = details.length;
                        //}
                        for (let Detail of details) {
                            delete Detail.ProcessId;
                            delete Detail.StockId;
                            delete Detail.PartyId;
                            Detail[this.getIdProperty()] = "`" + this.nextId++;
                            this.view.addItem(Detail);
                        }

                        // #endregion

                        // #endregion
                    }

                    

                    pickerDialog.dialogOpen();
                }
            });

            return buttons;
        }
        // #endregion


    }
}
